// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
let options = {"masterHistoryType":"browser","base":"/","apps":[{"name":"hr","entry":"//guoji.savvyuni.com.cn/savvyuni-hrms/","credential":true}]};
export const getMasterOptions = () => options;
export const setMasterOptions = (newOpts) => options = ({ ...options, ...newOpts });
